
export const navigation = [
    { key: "overview", label: "Overview", icon: "fa-chart-line" },
    { key: "profile", label: "Profile", icon: "fa-id-badge" },
    { key: "services", label: "Services", icon: "fa-wand-magic-sparkles" },
    { key: "calendar", label: "Calendar", icon: "fa-calendar-days" },
    { key: "clients", label: "Clients", icon: "fa-users" },
    // { key: "artists", label: "Artists", icon: "fa-user-check" },
    { key: "subscription", label: "Subscription", icon: "fa-credit-card" },
    { key: "notifications", label: "Notifications", icon: "fa-bell" },
    // { key: "booking", label: "Booking Link", icon: "fa-link" },
];

export const notifications = [
    "Booking confirmation email is ready",
    "Reminder email scheduled 24 hours before service",
    "Cancellation update template connected",
];

export const backendSlotTimes = [
    "8:00 am - 9:00 am",
    "9:00 am - 10:00 am",
    "10:00 am - 11:00 am",
    "11:00 am - 12:00 pm",
    "12:00 pm - 1:00 pm",
    "1:00 pm - 2:00 pm",
    "2:00 pm - 3:00 pm",
    "3:00 pm - 4:00 pm",
    "4:00 pm - 5:00 pm",
    "5:00 pm - 6:00 pm",
    "6:00 pm - 7:00 pm",
];

export const emptyDashboardData = {
    profile: null,
    stats: null,
    categories: [],
    subcategories: [],
    services: [],
    bookings: [],
    users: [],
    artists: [],
};

export const monthNames = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
];

export function getCategoryId(category) {
    console.log("Function called: getCategoryId");
    return category.categoryid || category.categoryId || category.id;
}

export function getSubcategoryId(subcategory) {
    console.log("Function called: getSubcategoryId");
    return subcategory.subcatid || subcategory.subcatId || subcategory.id;
}

export function formatDuration(time) {
    if (!time) return "";
    const timeStr = String(time).trim();
    if (/[a-zA-Z]/.test(timeStr)) {
        return timeStr;
    }
    if (timeStr.includes(":")) {
        const parts = timeStr.split(":");
        const hrs = parseInt(parts[0], 10);
        const mins = parseInt(parts[1], 10);
        if (!isNaN(hrs) && !isNaN(mins)) {
            if (hrs > 0 && mins > 0) {
                return `${hrs} Hr${hrs > 1 ? "s" : ""} ${mins} Min`;
            } else if (hrs > 0) {
                return `${hrs} Hr${hrs > 1 ? "s" : ""}`;
            } else if (mins > 0) {
                return `${mins} Min`;
            }
        }
    }
    if (timeStr.includes(".")) {
        const val = parseFloat(timeStr);
        if (!isNaN(val)) {
            if (val < 10) {
                const hrs = Math.floor(val);
                const mins = Math.round((val - hrs) * 60);
                if (hrs > 0 && mins > 0) {
                    return `${hrs} Hr${hrs > 1 ? "s" : ""} ${mins} Min`;
                } else if (hrs > 0) {
                    return `${hrs} Hr${hrs > 1 ? "s" : ""}`;
                } else if (mins > 0) {
                    return `${mins} Min`;
                }
            } else {
                return `${Math.round(val)} Min`;
            }
        }
    }
    const mins = parseInt(timeStr, 10);
    if (isNaN(mins)) return timeStr;
    if (mins < 60) {
        return `${mins} Min`;
    }
    const hrs = Math.floor(mins / 60);
    const remainingMins = mins % 60;
    if (remainingMins === 0) {
        return `${hrs} Hr${hrs > 1 ? "s" : ""}`;
    }
    return `${hrs} Hr${hrs > 1 ? "s" : ""} ${remainingMins} Min`;
}

export function normalizeService(service, categoryMap = new Map()) {
    return {
        id: service.serviceid || service.id || service.name,
        name: service.name || service.serviceName || "Untitled service",
        categoryId: service.categoryid || service.categoryId || "",
        subcatId: service.subcatid || service.subcatId || "",
        category: categoryMap.get(Number(service.categoryid || service.categoryId)) || service.category || "General",
        duration: formatDuration(service.time || service.duration) || "Not set",
        price: service.price ? `$${Number(service.price).toFixed(2)}` : "Not set",
        status: service.isactive === false ? "Inactive" : "Live",
        serviceImage: service.service_image || service.serviceImage || "",
        raw: service,
    };
}

export function normalizeBooking(booking) {
    console.log("Function called: normalizeBooking");
    const clientName = booking.customer_name ||
        booking.customer?.name ||
        booking.data?.customerName ||
        booking.data?.name ||
        "Customer";

    const serviceName = booking.services?.[0]?.service_name ||
        booking.services?.[0]?.name ||
        booking.service?.name ||
        booking.data?.serviceName ||
        "Service";

    return {
        id: booking.id || `${clientName}-${booking.booking_date}`,
        client: clientName,
        service: serviceName,
        date: booking.booking_date || booking.date || "Not set",
        time: booking.booking_time || booking.time || "Not set",
        status: booking.status || "Pending",
        duration: booking.duration ? formatDuration(booking.duration) : "",
    };
}

export function normalizeClient(user) {
    console.log("Function called: normalizeClient");
    const isActive = user.isactive ?? user.isActive;

    return {
        id: user.user_id || user.id || user.email,
        backendId: user.user_id || user.id || null,
        name: user.fullname || user.name || user.email || user.phone || "Customer",
        bookings: 0,
        lastVisit: user.created_at ? new Date(user.created_at).toLocaleDateString() : "Not available",
        note: user.note || "",
        history: "No bookings recorded",
        email: user.email || "Not added",
        phone: user.phone || "Not added",
        isActive: isActive !== false,
    };
}

export function getArtistId(artist) {
    console.log("Function called: getArtistId");
    return artist.id || artist.artist_id || artist.artistId || artist.user_id;
}

export function normalizeArtist(artist) {
    console.log("Function called: normalizeArtist");
    const data = artist.data || artist.profile || {};
    const name = artist.fullname || artist.name || data.fullName || data.fullname || data.name || artist.email || "Artist";

    return {
        id: getArtistId(artist),
        name,
        email: artist.email || data.email || "Not added",
        phone: artist.phone || data.phone || "Not added",
        city: artist.city || data.city || "",
        state: artist.state || data.state || "",
        category: artist.category || data.category || data.serviceCategory || "Artist",
        isVerified: Boolean(artist.is_verified ?? artist.isVerified ?? data.is_verified ?? data.isVerified),
        isSuspended: Boolean(artist.is_suspended ?? artist.isSuspended ?? data.is_suspended ?? data.isSuspended),
        raw: artist,
    };
}

export function normalizeBlog(blog) {
    console.log("Function called: normalizeBlog");
    return {
        id: blog.id,
        title: blog.title || "Untitled blog",
        description: blog.description || "",
        status: blog.status || "active",
        showIn: blog.showIn || blog.showin || "both",
        image: blog.image || "",
        createdAt: blog.createdAt || blog.created_at || "",
    };
}

export function normalizeSponsor(sponsor) {
    console.log("Function called: normalizeSponsor");
    return {
        id: sponsor.id,
        name: sponsor.name || "Untitled sponsor",
        order: sponsor.order ?? "",
        image: sponsor.image || "",
        details: sponsor.sponserDetails || sponsor.sponsorDetails || "",
        status: sponsor.status || "active",
    };
}

export function normalizeRentalStudio(studio) {
    console.log("Function called: normalizeRentalStudio");
    return {
        id: studio.id || studio.studio_id || studio.rental_studio_id,
        name: studio.name || studio.title || studio.studio_name || "Untitled studio",
        description: studio.description || studio.details || studio.studioDetails || "No studio details added.",
        city: studio.city || studio.city_name || "",
        state: studio.state || studio.state_name || "",
        pincode: studio.pincode || studio.zip || studio.zipcode || "",
        capacity: studio.capacity || studio.max_capacity || "Not set",
        price: studio.price_per_hour || studio.hourly_rate || studio.price || "Not set",
        image: studio.primary_image || studio.primaryImage || studio.image || "",
        status: studio.is_available === false || studio.isAvailable === false ? "Unavailable" : "Available",
    };
}

export function normalizePageant(pageant) {
    console.log("Function called: normalizePageant");
    return {
        id: pageant.id || pageant.pageant_id || pageant.pageantId,
        title: pageant.title || pageant.name || pageant.pageant_name || "Untitled pageant",
        description: pageant.description || pageant.details || pageant.about || "No pageant details added.",
        date: pageant.date || pageant.event_date || pageant.start_date || "",
        city: pageant.city || "",
        state: pageant.state || "",
        status: pageant.status || "active",
        image: pageant.image || pageant.banner_image || pageant.primary_image || "",
    };
}

export function getFloatingPopoverPosition(event, width = 420, estimatedHeight = 580) {
    console.log("Function called: getFloatingPopoverPosition");
    const gutter = 16;
    const topBoundary = typeof window !== "undefined" && window.innerWidth >= 768 ? 86 : gutter;
    const fallbackLeft = typeof window === "undefined" ? gutter : Math.max(gutter, Math.round((window.innerWidth - width) / 2));
    const fallbackTop = topBoundary;
    const fallbackMaxHeight = typeof window === "undefined" ? estimatedHeight : Math.max(300, window.innerHeight - fallbackTop - gutter);
    const fallback = { left: fallbackLeft, top: fallbackTop, maxHeight: fallbackMaxHeight };

    if (!event?.currentTarget || typeof window === "undefined") return fallback;

    const rect = event.currentTarget.getBoundingClientRect();
    const panelWidth = Math.min(width, window.innerWidth - gutter * 2);
    const maxPanelHeight = Math.min(estimatedHeight, window.innerHeight - topBoundary - gutter);
    const fitsRight = rect.right + gutter + panelWidth <= window.innerWidth;
    const rawLeft = fitsRight ? rect.right + gutter : rect.left - panelWidth - gutter;
    const left = Math.min(Math.max(gutter, rawLeft), Math.max(gutter, window.innerWidth - panelWidth - gutter));
    const canOpenDown = rect.top + maxPanelHeight + gutter <= window.innerHeight;
    const canOpenUp = rect.bottom - maxPanelHeight >= topBoundary;
    const centeredTop = rect.top + rect.height / 2 - maxPanelHeight / 2;
    const rawTop = canOpenDown ? rect.top - 8 : canOpenUp ? rect.bottom - maxPanelHeight : centeredTop;
    const top = Math.min(Math.max(topBoundary, rawTop), Math.max(topBoundary, window.innerHeight - maxPanelHeight - gutter));
    const maxHeight = Math.max(300, window.innerHeight - top - gutter);

    return { left: Math.round(left), top: Math.round(top), maxHeight: Math.round(maxHeight) };
}